export default __webpack_public_path__ + "static/media/parallax-bg38.cd63eb91.jpg";